import { Controller } from "@hotwired/stimulus"

// Allows only one <details> element inside this controller's scope to be
// open at a time: opening one closes the others.
export default class extends Controller {
  connect() {
    this.boundOnToggle = this.onToggle.bind(this)
    // The toggle event does not bubble, so listen in the capture phase
    this.element.addEventListener("toggle", this.boundOnToggle, true)
  }

  disconnect() {
    this.element.removeEventListener("toggle", this.boundOnToggle, true)
  }

  onToggle(event) {
    const opened = event.target
    if (!(opened instanceof HTMLDetailsElement) || !opened.open) return

    this.element.querySelectorAll("details[open]").forEach(details => {
      if (details !== opened) details.open = false
    })
  }
}
